import { Fancybox } from "@fancyapps/ui/dist/fancybox/";
import "@fancyapps/ui/dist/fancybox/fancybox.css";
import 'nouislider/dist/nouislider.css'; // Подключаем стили
import noUiSlider from 'nouislider';  
import Swiper from 'swiper/bundle';
import 'swiper/css/bundle';
window.Swiper = Swiper;

document.addEventListener('DOMContentLoaded', function() {


function formatPrice(price) {
    return Number(price).toLocaleString('ru-RU', {
        maximumFractionDigits: 0,
        useGrouping: true
    }).replace(/,/g, ' ');
}


function returnOnlyNumbers(string) {
    const clearString = String(string).replace(/\D/g, '');
    const numeric = parseInt(clearString) || 0;
    return numeric;
}





function calculateLoan(carPrice, percent, month, credit_rate ='') {
      const numericCarPrice = returnOnlyNumbers(carPrice);
      const initPay = numericCarPrice / 100 * returnOnlyNumbers(percent);
    // 
    let interestRate;
    if (!credit_rate) {
    interestRate = window.creditRate;
    }
    else {
     interestRate = credit_rate;
    }

// const interestRate = (credit_rate !== '') ? credit_rate : window.creditRate;

    const loanAmount = numericCarPrice - initPay; // Сумма кредита

    // Месячная процентная ставка
    const monthlyRate = interestRate / 12 / 100;
    const loanTermMonths = returnOnlyNumbers(month);
    // Расчёт аннуитетного платежа


    if (monthlyRate === 0) {
        const monthlyPayment = loanAmount / loanTermMonths;
        return {
            monthlyPayment: Math.round(monthlyPayment),
            totalPayment: Math.round(loanAmount),
            overpayment: 0
        };
    }

    const annuityPayment = loanAmount * 
        (monthlyRate * Math.pow(1 + monthlyRate, loanTermMonths)) / 
        (Math.pow(1 + monthlyRate, loanTermMonths) - 1);
    
    // Общая сумма к возврату
    const totalPayment = annuityPayment * loanTermMonths;
    
    // Переплата по кредиту
    const overpayment = totalPayment - loanAmount;
    
    return {
        monthlyPayment: Math.round(annuityPayment), // Ежемесячный платёж (округлённый)
        totalPayment: Math.round(totalPayment),     // Общая сумма выплат
        overpayment: Math.round(overpayment)        // Переплата
    };
}






const carSwiper = document.querySelector('.car-swiper');
if (carSwiper) {
      var swiper = new Swiper(".car__swiper-thumbs", {
      spaceBetween: 10,
      slidesPerView: 6,
      freeMode: true,
      watchSlidesProgress: true, pagination: {
                el: '.swiper-pagination-image',
                clickable: true,
            },
            navigation: {
                nextEl: '.car__swiper-thumbs-next',
                prevEl: '.car__swiper-thumbs-prev',
            },
    });
    var swiper2 = new Swiper(".car__swiper-big", {
      spaceBetween: 10,
  
      thumbs: {
        swiper: swiper,
      },
    });   

Fancybox.bind('[data-fancybox="gallery"]', {
    caption: function() { return ''; }
  // Your custom options for a specific gallery
});

}


let formatLoanTermSlider = {
    from: function (formattedValue) {
        return Number(formattedValue);
    },
    to: function(numericValue) {
        return formatPrice(numericValue) +' мес.' ;
    }
};



const sliderConfig = {
  behaviour: 'snap',
  values: [6, 12, 24, 36, 48, 60, 72, 84, 96],
  start: 96,
  connect: [true, false],
  tooltips:false,
 step:6,
    // padding:[6,0],
     range: {
        'min': [ 6,6     ],
        '10%': [  12, 12 ],
        'max': [ 96 ]
    },
// Включено прилипание
  format: formatLoanTermSlider,
  pips: {
    mode: "values",
    values: [6, 12, 24, 36, 48, 60, 72, 84, 96],
    density: 10,
    stepped: false,
    // format:formatLoanTermSlider,
  }
};
let formatDownPayForSlider = {
    from: function (formattedValue) {
        return Number(formattedValue);
    },
    to: function(numericValue) {
        return formatPrice(numericValue) +' %' ;
    }
};

const sliderConfig2 = {
  behaviour: 'snap',
  values: [0, 10, 20, 30, 40, 50, 60, 70, 80],
  start: 0,
  connect: [true, false],
  tooltips:false,
 step:10,
    // padding:[6,0],
  range: { min: 0, max: 80},
// Включено прилипание
  format: formatLoanTermSlider,
  pips: {
    mode: "values",
    values: [0, 10, 20, 30, 40, 50, 60, 70, 80],
    density: 10,
    stepped: false,
    format:formatDownPayForSlider,
  }
};

const sliderConfig3 = {
  behaviour: 'snap',
  values: [2,6,12,24,36],
  start: 0,
  connect: [true, false],
  tooltips:false,
//  step:10,
    // padding:[6,0],
  range: { min: 2, max: 36},
// Включено прилипание
  format: formatLoanTermSlider,
  pips: {
    mode: "values",
    values: [2,6,12,24,36],
    density: 10,
    stepped: false,

  }
};

const sliderConfig4 = {
  behaviour: 'snap',
  values: [0, 10, 20, 30, 40, 50, 60, 70],
  start: 0,
  connect: [true, false],
  tooltips:false,
//  step:10,
    // padding:[6,0],
  range: { min: 0, max: 70},
// Включено прилипание
  format: formatLoanTermSlider,
  pips: {
    mode: "values",
    values: [0, 10, 20, 30, 40, 50, 60, 70],
    density: 10,
    stepped: false,
    format:formatDownPayForSlider,
  }
};



  function animateValueChange(element, newValue) {
    element.classList.add('value-change');
    element.textContent = newValue;
    element.addEventListener('animationend', () => {
      element.classList.remove('value-change');
    }, {once: true});
  }


let sliders = {};



const creditButtons = document.querySelectorAll('.buy-credit');

if (creditButtons.length > 0) {
  
creditButtons.forEach((ctx)=>{

 ctx.addEventListener('click',()=>{
 const params = {
  title: "Заявка на автокредит",
  tabs: ["Скидка при покупке в кредит до 400 000 ₽", "Первоначальный взнос от 0%", "Кредит по 2 документам"],
  slider1: {title:`Срок кредита, мес.:<span class="show__month"></span>`},
  slider2: {title:'Первоначальный взнос:<span class="show__pay"></span>'}
  
};
showCarModal(params);

  });

})

const rassrochkaContainer = document.querySelectorAll('.installment');
rassrochkaContainer.forEach((ctx)=>{
 ctx.addEventListener('click',()=>{
 const params = {
  title: "Заявка на рассрочку",
  tabs: ["Первый взнос от 0%", "По паспорту и правам", "Trade-In как первый взнос"],
  slider3: {title:`Период рассрочки: <span class="show__month"></span>`},
  slider4: {title:'Первоначальный взнос:<span class="show__pay"></span>'}
  
};
showCarModal(params);

  });
})

const tradeInLinks = document.querySelectorAll('.tradin-link');

tradeInLinks.forEach((ctx)=>{
 ctx.addEventListener('click',()=>{
 const params = {
  title: "Заявка на Trade-In",
  tabs: ["Выгода по Trade-In","Trade-In как первый взнос", "По паспорту и правам","Рыночная цена" ],
  slider1: {title:`Срок кредита, мес. <span class="show__month"></span>`},
  slider2: {title:'Первоначальный взнос:<span class="show__pay"></span>'},
  tradein:true
};
showCarModal(params);

  });
})

const vinReport = document.querySelector('.open-vin');
if (vinReport) {
 
vinReport.addEventListener('click', ()=> {
 const params = {
  title: "Закажите полный отчет об этом автомобиле!",
  vin:true
};
showCarModal(params);
}); 
}


const callBackLinks = document.querySelectorAll('.call');

callBackLinks.forEach((ctx)=>{
 ctx.addEventListener('click',()=>{
 const params = {
  title: "Обратный звонок",

};
showCarModal(params);

  });
})
const diffModals = document.querySelectorAll('.modal-show');
diffModals.forEach((ctx)=>{
 ctx.addEventListener('click',()=>{
  let getTitle = ctx.textContent;
 const params = {
  title: getTitle,

};
showCarModal(params);

  });
})


}
    const modal = document.querySelector('.modal__car');
    const modalBg = document.querySelector('.modal-car-bg');
    const closeModal = document.querySelector('.close-modal-car');



function closeModalWindow() {
      const carComplectation = document.querySelector('.complection');
    modalBg.classList.remove('active');
    modal.classList.remove('active');
    if (carComplectation) {
         carComplectation.classList.remove('active');
    }
}

modalBg.addEventListener('click', function(e) {
    // Проверяем, что кликнули именно на фон, а не на содержимое модалки
    if (e.target === modalBg) {
        closeModalWindow();
    }
});

closeModal.addEventListener('click', (closeModalWindow));


function showCarModal(params) {

const existingInput = document.querySelector('input[name="user_trade_in"]');
if (existingInput) {
  existingInput.remove();
}

    modal.classList.add('active');
    modalBg.classList.add('active');
    let typeOfForm = document.querySelector('.car__modal-type');
    

    const title = document.querySelector('.modal__car-title');
    const slidersContainer = document.querySelector('.sliders');
    const showMonthPayment = document.querySelector('.modal__car-payment');
    showMonthPayment.classList.remove('active');

    title.textContent = params.title;
      const tabsContainer = document.querySelector('.modal__car-tabs');
      tabsContainer.innerHTML = '';
      slidersContainer.innerHTML = '';
   if (params.tabs && tabsContainer) {
  params.tabs.forEach((tabName) => {
    const tabElement = document.createElement('div');
    tabElement.className = 'item';
    tabElement.textContent = tabName;
    tabsContainer.appendChild(tabElement);
  });
}

if (params.slider1) {
     showMonthPayment.classList.add('active');
 const sliderEl = createSlider(slidersContainer, params.slider1, sliderConfig,'slider1');
 sliders.slider1 = sliderEl.noUiSlider; 
  if (sliders.slider3) {
        sliders.slider3.destroy();
        sliders.slider4.destroy();
          delete sliders.slider3;
          delete sliders.slider4;
  }
}
if (params.slider2) {
 const sliderEl = createSlider(slidersContainer, params.slider2, sliderConfig2,'slider2');
   sliders.slider2 = sliderEl.noUiSlider; 
}
if (params.slider3) {
  if (sliders.slider1) {
        sliders.slider1.destroy();
        sliders.slider2.destroy();
          delete sliders.slider1;
          delete sliders.slider2;
  }

  
     showMonthPayment.classList.add('active');
 const sliderEl = createSlider(slidersContainer, params.slider3, sliderConfig3,'slider1');
   sliders.slider3 = sliderEl.noUiSlider; 
}
if (params.slider4) {
 const sliderEl = createSlider(slidersContainer, params.slider4, sliderConfig4,'slider1');
   sliders.slider4 = sliderEl.noUiSlider; 
}


if (params.slider1 || params.slider3) {
  

Object.values(sliders).forEach(slider => {
    slider.on('update', handleSliderUpdate);
});

}

const form = document.querySelector('.car__modal-form-wrap .standart-form');

if (params.tradein) {
  const input = document.createElement('input');
input.setAttribute('type', 'text');
input.setAttribute('name', 'user_trade_in');
input.setAttribute('placeholder', 'Ваш автомобиль');
  form.prepend(input);

  const inCredit = document.createElement('div');
  inCredit.className = 'incredit';

  const checkBox = document.createElement('input');
  checkBox.setAttribute('type', 'checkbox');
  checkBox.setAttribute('id', 'ifc');
  checkBox.setAttribute('checked', 'checked');

  inCredit.innerHTML = '<label for="ifc" class="container-custom">Купить в кредит</label>';
  inCredit.querySelector('label').prepend(checkBox);
   const span = document.createElement('span');
    span.className = 'checkmark-check';
    inCredit.querySelector('label').append(span);
slidersContainer.prepend(inCredit);


  const sliderContainer = document.querySelectorAll('.slider-container');

  checkBox.addEventListener('change', function() {
    if (this.checked) {
      // Если чекбокс включен
      showMonthPayment.classList.add('active');
      sliderContainer.forEach(ctx=>{
   ctx.classList.add('active');
      ctx.classList.remove('inactive');
      });
   
    } else {
       showMonthPayment.classList.remove('active');
            sliderContainer.forEach(ctx=>{
   ctx.classList.add('inactive');
      ctx.classList.remove('active');
      });
   
    }
  });
}



}


function handleSliderUpdate() {
  const priceContainer = document.querySelector('.actual'); 
    const price = returnOnlyNumbers(priceContainer.textContent);
    let sliderFirst, sliderSecond;
    let creditRate;

      if (sliders.slider1) {
        sliderFirst = sliders.slider1.get();
        sliderSecond = sliders.slider2.get();
      }
      else {
          sliderFirst = sliders.slider3.get();
          sliderSecond = sliders.slider4.get();
          creditRate = Number(window.creditRate) - Number(3);
    
      }

 

   let perMonth  = calculateLoan(price,sliderSecond,sliderFirst,creditRate);

    const monthPay = document.querySelector('.modal__car-payment .price');

    // const monthPayOnPlate = document.querySelector('.price');
    const totalCreditSum = returnOnlyNumbers(price);

    const firstPayment = (totalCreditSum / 100) *  returnOnlyNumbers(sliderSecond);
    monthPay.textContent = formatPrice(perMonth.monthlyPayment) + ' ₽';
    animateValueChange(monthPay,formatPrice(perMonth.monthlyPayment));

    const showMonthes = document.querySelector('.show__month');
    const showPaym = document.querySelector('.show__pay');
    showMonthes.textContent = sliderFirst ;
    showPaym.textContent = formatPrice(firstPayment) + ' ₽' ;


}




function createSlider(container, sliderParams, sliderConfig,customClass = '') {
  const sliderContainer = document.createElement('div');
  sliderContainer.className = 'slider-container';
  
  const title = document.createElement('h3');
  title.innerHTML = sliderParams.title;
  sliderContainer.appendChild(title);

  const sliderEl = document.createElement('div');
  sliderEl.className = `slider ${customClass}`;
  sliderContainer.appendChild(sliderEl);
 
  container.appendChild(sliderContainer);
  noUiSlider.create(sliderEl, sliderConfig);
  return sliderEl;
}

let carID = document.querySelector('.car-number').textContent;
carID = returnOnlyNumbers(carID);

const showComplectLinks = document.querySelectorAll('.show-more-block');
showComplectLinks.forEach(ctx=>{
ctx.addEventListener('click',()=>{
getComplectation();

});
})


async function getComplectation(){
   try {
        // 1. Создаем объект с данными запроса
        const requestData = {
              carID: carID
        };
               

        const response = await fetch('/api/car-complect', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'X-Requested-With': 'XMLHttpRequest'
            },
            body: JSON.stringify(requestData) // Используем requestData здесь
        });
        
        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }
        const container = document.querySelector('.complect');
        const data = await response.json();
        container.innerHTML = data.html;
        showComplectInfo();
    } catch (error) {
        console.error('Error loading cars:', error);

    } finally {
  

    }
}


function showComplectInfo() {
  const modal = document.querySelector('.complection');
    const close = document.querySelector('.close-complect');
    close.addEventListener('click', closeModalWindow);

    if (window.outerWidth <=768) {
          modal.style.left = '-100%';

  setTimeout(()=>{
 modal.style.left = 0;
  },100);
    }

  modal.classList.add('active');
  modalBg.classList.add('active');
}



function throttle(func, limit) {
  let lastFunc;
  let lastRan;
  return function(...args) {  // Используем rest-параметры вместо arguments
    const context = this;    // Сохраняем контекст
    
    if (!lastRan) {
      // Первый вызов
      func.apply(context, args);
      lastRan = Date.now();
    } else {
      // Очищаем предыдущий таймаут
      clearTimeout(lastFunc);
      
      // Устанавливаем новый таймаут
      lastFunc = setTimeout(() => {
        if ((Date.now() - lastRan) >= limit) {
          func.apply(context, args);
          lastRan = Date.now();
        }
      }, limit - (Date.now() - lastRan));
    }
  }
}

     if (window.innerWidth <= 768) {

      window.addEventListener('scroll', throttle(checkIfScrolledPast, 200));

     }

    let isSticky = false;
         const firstBlock = document.querySelector('.first-block');
    const thirdBlock = document.querySelector('.third-block');
    
    let lastScrollPosition = window.pageYOffset;

     function checkIfScrolledPast() {



const currentScrollPosition = window.pageYOffset;
        const thirdBlockRect = thirdBlock.getBoundingClientRect();
        
        // Проверяем, достигли ли верхней границы third-block
        if (thirdBlockRect.top <= 0) {
            if (!isSticky) {
                firstBlock.classList.add('sticky');
                isSticky = true;
            }
            
            // Определяем направление скролла
            if (currentScrollPosition > lastScrollPosition) {
                // Скролл вниз
                firstBlock.classList.add('up');
            } else {
                // Скролл вверх
                firstBlock.classList.remove('up');
            }
        } else {
            if (isSticky) {
                firstBlock.classList.remove('sticky');
                firstBlock.classList.remove('up');
                isSticky = false;
            }
        }
        
        lastScrollPosition = currentScrollPosition;




     }

   const creditCheckbox = document.querySelector('input[name="check_cred"]');
    const tradeCheckbox = document.querySelector('input[name="check_trade"]');
    const actualPriceElement = document.querySelector('.actual');
     if (creditCheckbox) {
      
       let basePrice = 0;
    
    // Функция для получения базовой цены из элемента
    function getBasePrice() {
        // Получаем текущий текст, убираем " ₽" и все кроме цифр
        const currentText = actualPriceElement.textContent.trim();
        // Убираем "₽" и пробелы, оставляем только цифры
        const numbers = currentText.replace(/[^\d]/g, '');
        return parseInt(numbers) || 0;
    }

 function updatePrice() {
        // Получаем значения скидок (если чекбокс отмечен)
        let totalDiscount = 0;
        
        if (creditCheckbox && creditCheckbox.checked) {
            totalDiscount += parseInt(creditCheckbox.dataset.value) || 0;
        }
        
        if (tradeCheckbox && tradeCheckbox.checked) {
            totalDiscount += parseInt(tradeCheckbox.dataset.value) || 0;
        }
        
        // Вычисляем финальную цену
        const finalPrice = basePrice - totalDiscount;
        
        // Обновляем текст
        const priceText = actualPriceElement.textContent;
        // Заменяем число в тексте, сохраняя остальной контент
        const newText = priceText.replace(/[\d\s]+(?=₽)/, formatPrice(finalPrice));
        // Обновляем только текстовое содержимое, сохраняя HTML для tooltip
        const icon = actualPriceElement.querySelector('.icon');
        actualPriceElement.innerHTML = formatPrice(finalPrice) + ' ₽ ';
        if (icon) {
            actualPriceElement.appendChild(icon);
        }
        
        // Обновляем атрибут data-price если нужно
        actualPriceElement.dataset.price = finalPrice;
    }

function initBasePrice() {
        // Получаем сумму всех скидок, которые отмечены
        let initialDiscount = 0;
        
        if (creditCheckbox && creditCheckbox.checked) {
            initialDiscount += parseInt(creditCheckbox.dataset.value) || 0;
        }
        
        if (tradeCheckbox && tradeCheckbox.checked) {
            initialDiscount += parseInt(tradeCheckbox.dataset.value) || 0;
        }
        
        // Получаем текущую отображаемую цену
        const currentPrice = getBasePrice();
        
        // Вычисляем базовую цену (без скидок)
        basePrice = currentPrice + initialDiscount;
    }
     initBasePrice();
    
    // Добавляем обработчики событий
    if (creditCheckbox) {
        creditCheckbox.addEventListener('change', updatePrice);
    }
    
    if (tradeCheckbox) {
        tradeCheckbox.addEventListener('change', updatePrice);
    }


     }



});